import { ICSVData, IHeaderOption, IParseCSVOptions } from 'common/types';
import {
    EMAIL_PATTERN,
    matchHeadersToOptions,
    parseCSV,
} from 'common/utils/csv';
import { IImportUserHeader } from 'graphql/types';

const USER_KNOWN_HEADERS = new Set([
    'email',
    'e-mail',
    'first_name',
    'firstname',
    'first name',
    'voornaam',
    'last_name',
    'lastname',
    'last name',
    'achternaam',
    'name',
    'naam',
    'language',
    'taal',
]);

const USER_CSV_OPTIONS: IParseCSVOptions = {
    knownHeaders: USER_KNOWN_HEADERS,
    dataPattern: EMAIL_PATTERN,
};

const USER_HEADER_ALIASES: Record<string, IImportUserHeader> = {
    email: IImportUserHeader.Email,
    'e-mail': IImportUserHeader.Email,
    first_name: IImportUserHeader.FirstName,
    firstname: IImportUserHeader.FirstName,
    'first name': IImportUserHeader.FirstName,
    voornaam: IImportUserHeader.FirstName,
    last_name: IImportUserHeader.LastName,
    lastname: IImportUserHeader.LastName,
    'last name': IImportUserHeader.LastName,
    achternaam: IImportUserHeader.LastName,
    name: IImportUserHeader.Name,
    naam: IImportUserHeader.Name,
    language: IImportUserHeader.Language,
    taal: IImportUserHeader.Language,
};

export function matchUserHeadersToOptions(
    headers: string[],
    options: IHeaderOption<string>[]
): string[] {
    return matchHeadersToOptions(headers, options, {
        aliases: USER_HEADER_ALIASES,
        ignoreValue: IImportUserHeader.Ignore,
    });
}

export function parseUserCsv(content: string): ICSVData {
    return parseCSV(content, USER_CSV_OPTIONS);
}
